import {useState} from 'react';
import {rowSelectionDefaults} from '../defaults';
import type {CustomVirtualizedSelection} from '../types';

export type UseNetxRowSelectionParams = {
	initialSelection?: CustomVirtualizedSelection;
};

export const useNetxRowSelection = ({
	initialSelection,
}: UseNetxRowSelectionParams = {}) => {
	return useState<CustomVirtualizedSelection>({
		...rowSelectionDefaults,
		...initialSelection,
	});
};
